import { nlpIntegration } from '@mi-front/api-clients';

/**
 * Returns the display summary for a topic: refined_summary when present and non-empty, otherwise summary.
 */
export function getTopicDisplaySummary(topic: nlpIntegration.TopicOutDto): string {
  if (topic.refined_summary) {
    return topic.refined_summary;
  }

  return topic.summary;
}
